import React, { useCallback } from 'react';
import ReactLinkify from 'react-linkify';
import { Dialog } from "../../Dialog/Dialog";
import { DialogActions } from "../../Dialog/DialogActions";
import { DialogButton } from "../../Dialog/DialogButton";
import { DialogContent } from "../../Dialog/DialogContent";
import { DialogContentText } from "../../Dialog/DialogContentText";
import { DialogTitle } from "../../Dialog/DialogTitle";
import { useNotificationUrlParams } from "../../../hooks/useNotificationUrlParams";
import { makeStyles } from "../../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    title: {
        padding: theme.spacing(0, 2),
    },
    text: {
        '& p': {
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere',
            textAlign: 'left',
        },
    },
}); });
/**
 * お知らせ表示用ダイアログ
 */
export var NotificationDialog = function (_a) {
    var open = _a.open, notification = _a.notification, notificationUrlParamsProps = _a.notificationUrlParamsProps, onOk = _a.onOk;
    var classes = useStyles();
    var decorateUrlWithNotificationParams = useNotificationUrlParams(notificationUrlParamsProps).decorateUrlWithNotificationParams;
    var decorator = useCallback(function (href, text, key) {
        return (React.createElement("a", { key: key, href: decorateUrlWithNotificationParams(href), target: "_blank", rel: "noopener noreferrer" }, text));
    }, [decorateUrlWithNotificationParams]);
    // ダイアログのrootにdata-test-id属性としてお知らせIDをセットする
    var handleDialogRef = useCallback(function (element) {
        element === null || element === void 0 ? void 0 : element.setAttribute('data-test-id', "notification-dialog-" + notification.id);
    }, [notification.id]);
    return (React.createElement(Dialog, { open: open, ref: handleDialogRef },
        React.createElement(DialogTitle, { className: classes.title }, notification.title),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { className: classes.text },
                React.createElement(ReactLinkify, { componentDecorator: decorator }, notification.message))),
        React.createElement(DialogActions, null,
            React.createElement(DialogButton, { fill: true, onClick: onOk }, "OK"))));
};
